/**
 * Reusable component to diplay a user link with optional avatar.
 * TODO: Maybe on hover have a popup with larger image, full name, etc.
 */

import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Image} from 'semantic-ui-react';

import {profilePage} from '../../util/urls';
// @todo: Migrate to 'Link' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Link} from './Link';

type UserProps = {
  username: string;
  photoUrl?: string;
};

export const User = ({photoUrl, username}: UserProps) => {
  const urlProfile = profilePage(username);

  const image = photoUrl ? (
    <Image
      src={photoUrl}
      avatar
      onError={(i: any) => (i.target.style.display = 'none')}
    />
  ) : null;

  return (
    <Link to={urlProfile}>
      {image}
      {username}
    </Link>
  );
};
